import type { JSX } from "react";

import { GuideFigure } from "../../GuideSection";
import type { SectionRenderInput } from "./types";

/**
 * A LITTLE HISTORY. The guide opens here.
 *
 * The guide's first section is also the page's one full-bleed spread: the band
 * runs to the viewport edges while the prose stays in the column. The figure
 * leads in the DOM, so reading order still matches what the eye sees. Without
 * one, the row takes the whole width — the modifier the stylesheet reads.
 */
export function HistorySection({ page }: SectionRenderInput): JSX.Element {
  const image = page.sectionImages?.history;
  return (
    <div
      className={`atlas-guide-row atlas-guide-row--bleed${image ? "" : " atlas-guide-row--text-only"}`}
    >
      {image && <GuideFigure image={image} />}
      <p className="atlas-guide-prose whitespace-pre-line">{page.history}</p>
    </div>
  );
}
